import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import React, { useState, useEffect } from 'react';


import ApiFetch from '../data/APIFetch';
import InventoryList from '../modules/ListInventory';
import { useParams } from 'react-router-dom';
import ImageContainer from '../blocks/UIImageContainer';

import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import { INTRFItem, AppItem } from '../../hooks/Interfaces';
import { privateDecrypt } from 'crypto';

interface ApplicationProps {
    updatefunc: () => void;
}



function InventoryItemPage({updatefunc}: ApplicationProps){
    // Extract the specific variable name defined in your route
    const [item, setItem]  = useState(AppItem());
    const [image, setImage] = useState("/mock-assets/al1.png");
    const [itemid, setItemID] = useState("123456789");
    const [size, setSize] = useState(0);
    const [price, setPrice] = useState(0);
    const [brandname, setBrandName] = useState("Locating item...");
    const [type, setType] = useState("Locating item.");
    const [description, setDescription] = useState("Lorem ipsum. whole lot of text. A whole lot of words");

    const [details, setDetails] = useState(["ABV: 40%", "Proof: 80"]);

    const { productid } = useParams();

    /** Config */
    let axiosConfig = GetHeaders();
    const posturl = process.env.REACT_APP_API_URL + "/v1/catalogue/inventory/" + productid;

    /* Component Init */
    useEffect(() => {
        
        if(item.itemid == ""){
            GetInventory();
        }
        setBrandName(item.name)
        setSize(item.size)
        setItemID(item.itemid)
        setDescription(item.description)
        setImage(item.image)
        setPrice(item.price)

    }, [item]);

    const GetInventory = async () => {
        //setLoading(true);
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: {}})
        //Handle a Non 200 response
        setItem(response.item)
        /*setBrandName(item.name)
        setSize(item.size)
        setItemID(item.itemid)
        setDescription(item.description)
        setImage(item.image)*/
        //setLoading(false);
        console.log("running func")
    }

    const handlesubmit = async () => {
        

        //setLoading(true);
        let iteminfo = {
            'product_id': item.itemid,
            'count': 1 //change later
        }
        let posturl = process.env.REACT_APP_API_URL + "/v1/commerce/cart/update";
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: iteminfo})

        //Handle a Non 200 response
        if(response.status == 200){
            window.location.reload();
        }else{
            //Error handling
            console.log(response)
        }
    }

    

    
    return (
        <> 
            <Container>
                <Row>
                    <Col md={{ span: 4 }}>
                        <Row>
                            <ImageContainer img_url={image} /> 
                        </Row>
                    
                    </Col>
                    <Col md={{ span: 8 }}>
                        
                        <Row>
                            <h1 className="text-font-body text-font-size-large text-font-heavy text-start">{brandname}</h1>
                        </Row>
                        <Row>
                            <p className="text-font-body text-font-size-large text-font-medium text-start">{type}</p>
                        </Row>
                        <Row>
                            <p className="text-font-body text-font-size-medium text-font-medium text-start">Price / Size Varients</p>
                        </Row>
                        <Row className="py-2">
                            <Col>
                            <p>${price.toFixed(2)}</p>
                            </Col>
                            <Col>
                                <button type="button" className="btn brand-btn-tertiary-color-alt input-fill">{size} ML</button>
                            </Col>
                            
                        </Row>
                        <form onSubmit={handlesubmit}>
                            <Row>
                                <button type="submit" className="btn brand-btn-secondary-color input-fill">Add to Cart</button>
                            </Row>
                        </form>
                        { description &&
                            <Row>
                                <p className="text-font-body text-font-size-medium text-font-medium text-start">Description:</p>
                                <p className="text-font-body text-font-size-medium text-font-light text-start">{description}</p>
                            </Row>
                        }
                        <Row>
                            <p className="text-font-body text-font-size-medium text-font-medium text-start">Product Details:</p>

                            {details.map( (detail, index)  => 
                                <Row key={index} className="py-0">
                                    <p className="py-0 text-font-body text-font-size-medium text-font-light text-start">{detail}</p>
                                </Row>)
                            }
                        </Row>
                        <Row>
                            <p className="text-font-body text-font-size-small text-font-light text-start" >Inventory Item: {itemid}</p>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    Related / Also see...
                </Row>
                
                
                
                
            </Container>
        </>
    )
}

export default InventoryItemPage;